export default __webpack_public_path__ + "static/media/IMG_9968.78f80656.jpg";